import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StorageHelper } from '../../../utils/StorageHelper';
import { useAppStore } from '../../../store/AppContext';
import useAPIError from '../../../hooks/useAPIError';
import DataService from '../../../services/MisDatosService';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { FooterConstants } from '../../../utils/FooterConstants';
import { useMisDatosStore } from '../../MisDatos/context/MisDatos.context';

interface Props {
  hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
}

const WaMenuSocioClubLink: FC<Props> = (props) => {
  const { event_action, event_category, event_label, hittype } = props;
  const dataApp = useAppStore();
  const {
    showModalTelefono1,
    showModalContactEmail,
    showFlagTelefono1Incorrecto,
  } = useMisDatosStore();
  const { access, lang, handleModalDatosPersonales } = dataApp;
  const [showError, setShowError] = useState(false);
  const [showDniError, setShowDniError] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [typeError, setTypeError] = useState<number>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { addError } = useAPIError();
  const { t } = useTranslation();
  const APP_BASE_URL = document.location.hostname.includes('eroski.es')
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_CAPRABO;
  const getHTMLContent = () => {
    return `${t(
      'tarjetas.tarjeta-socio.error-AME-sac-prevalidation-message',
    )} <a href="tel:944943444" style="color: #4a90e2; text-decoration: none;">${
      FooterConstants.TELEFONO_ATENCION_CLIENTE
    }.</a>`;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault(); // Prevenir la acción por defecto del enlace

    DataService.checkPrevalidacionDatosAltaClub()
      .then((responsePrevalidacion) => {
        if (responsePrevalidacion.data.error) {
          setMessageError(
            t('tarjetas.tarjeta-socio.error-AME-prevalidation-message'),
          );
          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
          ) {
            setShowError(true);
            setTypeError(
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION,
            );
          }
          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
          ) {
            setShowError(true);
            setTypeError(
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION,
            );
          }
          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_CLIENTEV0_DNI_NO_EDITABLE_SAC
          ) {
            setShowDniError(true);
          }
          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
          ) {
            setTypeError(
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION,
            );
            setShowError(true);
          }
          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
          ) {
            setTypeError(
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION,
            );
            setShowError(true);
          }
        } else {
          StorageHelper.deleteUserFromSessionAndRedirect(
            access.solicitarTarjeta,
            lang,
            APP_BASE_URL,
            e,
            '',
          );
        }
      })
      .catch((er: any) => {
        console.log(er);
        setMessageError(t('nlr-vaya-algo-no-ha-ido-bien'));
        setShowError(true);
      });
  };

  const goToMisDatosAndOpenModal = () => {
    if (
      typeError ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
    ) {
      const formDireccion = document.querySelector(
        '[id^="habitual-"]',
      ) as HTMLFormElement;
      if (formDireccion) {
        formDireccion.classList.add('visible');
        const submitButtons = document.querySelectorAll(
          '[id^="direccion-submit-btn-"]',
        );
        const button = submitButtons[0] as HTMLElement;
        button.click();
      }
    } else if (
      typeError ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
    ) {
      StorageHelper.setOpenAltaClubPersonalData();
      handleModalDatosPersonales(true);
    } else if (
      typeError ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
    ) {
      showModalTelefono1();
      showFlagTelefono1Incorrecto();
    } else if (
      typeError ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
    ) {
      showModalContactEmail();
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {
    StorageHelper.removeOpenAltaClubPersonalData();
    handleModalDatosPersonales(false);
  };

  return (
    <>
      <div className="icon-link-block">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          data-wa-hittype={hittype}
          data-wa-event-category={event_category}
          data-wa-event-action={event_action}
          data-wa-event-label={event_label}
          href=""
          onClick={handleClick}
          className="icon-link icon-link__oro"
        >
          <img src={access.solicitarTarjeta?.urlImagen} alt="" />
          <span>{access.solicitarTarjeta?.descripcion}</span>
        </a>
      </div>
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showError}
        setShowModal={setShowError}
        title=""
        textHTMLContent={t(messageError)}
        doAceptar={goToMisDatosAndOpenModal}
        doClose={emptymethod}
        showCancel={false}
        acceptButtonTextKey={t('datos.accessdata.accept')}
        hideXButton
      />
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showDniError}
        setShowModal={setShowDniError}
        title={t('nlr-vaya-algo-no-ha-ido-bien')}
        textHTMLContent={getHTMLContent()}
        doAceptar={() => null}
        doClose={emptymethod}
        showCancel={false}
        acceptButtonTextKey={t('entendido')}
        hideXButton
      />
    </>
  );
};

export default WaMenuSocioClubLink;
